import { SelectOutlined } from "@ant-design/icons";
import { Button, Col, Descriptions, Form, Row, Upload } from "antd";
import { useState } from "react";
import { TableUi } from "../../ui";

const columns = [
  {
    title: "# Fila",
    dataIndex: "row",
    key: "row",
  },
  {
    title: "Mensajes",
    dataIndex: "errors",
    key: "errors",
    render: (text, record, index) => <>{JSON.stringify(record?.errors)}</>,
  },
];
const items = (importedSummary) => [
  {
    label: "Nuevos",
    children: importedSummary?.nuevos,
  },
  {
    label: "Actualizados",
    children: importedSummary?.actualizados,
  },
  {
    label: "Omitidos",
    children: importedSummary?.omitidos,
  },
  {
    label: "Total exitosos",
    children: importedSummary?.total_exitosos,
  },
];
export const ImportarDatosForm = ({ importedsummary, errors }) => {
  const [fileList, setFileList] = useState([]);
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList.slice(-1);
  };
  const props = {
    // onRemove: (file) => {
    // },
    beforeUpload: async (file) => {
      return false;
    },
    fileList,
  };
  return (
    <>
      <Row>
        <Col span={24}>
          <Form.Item
            name="fileExcel"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[
              { required: true, message: "Seleccione el excel a importar" },
            ]}
          >
            <Upload
              key="subirExcel"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              maxCount={1}
              multiple={false}
              {...props}
            >
              <Button
                color="primary"
                variant="outlined"
                icon={<SelectOutlined />}
              >
                Seleccionar archivo
              </Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      {errors?.length > 0 && (
        <Row>
          <Col span={24}>
            <TableUi columns={columns} data={errors} size="small" />
          </Col>
        </Row>
      )}
      {importedsummary && (
        <Row>
          <Col span={12}>
            <Descriptions
              bordered
              title="Resumen de importación"
              styles={{ header: { marginBottom: 6 } }}
              items={items(importedsummary)}
              size="small"
              column={1}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
